(() => {
  if (customElements.get('mobile-filter-panel')) return;
  class MobileFilterPanel extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.panel = this.querySelector('.mobile-filter-content');
      this.form = this.querySelector('form');
      this.classList.add('is-enhanced');
      this.querySelector('[data-filter-close-button]').hidden = false;
      this.querySelector('[data-filter-backdrop]').hidden = false;
      this.querySelector('[data-filter-clear]').hidden = false;
      this.onToggle ||= (event) => {
        if (event.target !== this.details) return;
        if (this.details.open) {
          this.snapshot = Array.from(this.form.elements).map((control) => ({ control, value: control.value, checked: control.checked }));
          document.body.classList.add('mobile-filter-lock');
          this.panel.setAttribute('role', 'dialog');
          this.panel.setAttribute('aria-modal', 'true');
          this.panel.setAttribute('aria-label', this.querySelector('h2').textContent);
          if (typeof trapFocus === 'function') trapFocus(this.panel, this.querySelector('[data-filter-close-button]'));
          this.renderSelections();
        } else {
          document.body.classList.remove('mobile-filter-lock');
          this.panel.removeAttribute('aria-modal');
          this.panel.removeAttribute('role');
          this.panel.removeAttribute('aria-label');
          this.snapshot?.forEach(({ control, value, checked }) => { control.value = value; if (typeof checked === 'boolean') control.checked = checked; });
          if (typeof removeTrapFocus === 'function') removeTrapFocus(this.details.querySelector('summary'));
        }
      };
      this.onInput ||= () => this.renderSelections();
      this.onClick ||= (event) => {
        if (event.target.closest('[data-filter-close]')) this.details.open = false;
        if (event.target.closest('[data-filter-clear]')) {
          Array.from(this.form.elements).filter((control) => control.name?.startsWith('filter.')).forEach((control) => {
            if (control.type === 'checkbox') control.checked = false; else control.value = '';
          });
          this.renderSelections();
        }
      };
      this.onKey ||= (event) => { if (event.key === 'Escape' && this.details.open) { event.preventDefault(); event.stopPropagation(); this.details.open = false; } };
      this.details.addEventListener('toggle', this.onToggle);
      this.addEventListener('input', this.onInput);
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKey);
    }
    disconnectedCallback() {
      this.details?.removeEventListener('toggle', this.onToggle);
      this.removeEventListener('input', this.onInput); this.removeEventListener('click', this.onClick); this.removeEventListener('keydown', this.onKey);
      if (this.details?.open) { document.body.classList.remove('mobile-filter-lock'); if (typeof removeTrapFocus === 'function') removeTrapFocus(); }
    }
    selectedControls() {
      return Array.from(this.form.elements).filter((control) => control.name?.startsWith('filter.') && !control.disabled && (control.type === 'checkbox' ? control.checked : control.value !== ''));
    }
    renderSelections() {
      const target = this.querySelector('[data-filter-selections]');
      target.replaceChildren();
      const selected = this.selectedControls();
      selected.forEach((control) => {
        const button = document.createElement('button');
        button.type = 'button';
        const label = control.dataset.label || `${control.labels?.[0]?.textContent.trim() || 'Price'}: ${control.value}`;
        button.textContent = `${label} ×`;
        button.setAttribute('aria-label', `Remove ${label}`);
        button.addEventListener('click', () => {
          if (control.type === 'checkbox') control.checked = false; else control.value = '';
          this.renderSelections();
          (target.querySelector('button') || this.querySelector('[data-filter-clear]')).focus();
        });
        target.append(button);
      });
      this.querySelector('[data-filter-status]').textContent = `${selected.length} filters selected. Show products to apply.`;
    }
  }
  class CollectionPhotoSwitch extends HTMLElement {
    connectedCallback() {
      this.hidden = false;
      this.originals ||= new WeakMap();
      this.view = 'product';
      try { this.view = sessionStorage.getItem('asenmo-photo-view') === 'model' ? 'model' : 'product'; } catch (_) {}
      this.onClick ||= (event) => {
        const button = event.target.closest('[data-photo-view]');
        if (!button) return;
        this.view = button.dataset.photoView;
        try { sessionStorage.setItem('asenmo-photo-view', this.view); } catch (_) {}
        this.apply();
      };
      this.addEventListener('click', this.onClick);
      this.observer = new MutationObserver(() => this.apply());
      const grid = document.getElementById('ProductGridContainer');
      if (grid) this.observer.observe(grid, { childList: true, subtree: true });
      this.apply();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.observer?.disconnect();
      document.querySelectorAll('#ProductGridContainer .card-photo-data').forEach((data) => {
        const container = data.closest('.card__media');
        const image = container?.querySelector('.media > img');
        const original = image && this.originals?.get(image);
        if (!original) return;
        if (original.onError) image.removeEventListener('error', original.onError);
        original.onError = null;
        image.setAttribute('src', original.src);
        if (original.srcset) image.setAttribute('srcset', original.srcset);
        else image.removeAttribute('srcset');
        image.alt = original.alt;
        container.classList.remove('card-photo-active');
        delete data.dataset.appliedView;
      });
    }
    apply() {
      document.querySelectorAll('#ProductGridContainer .card-photo-data').forEach((data) => {
        const container = data.closest('.card__media');
        const image = container?.querySelector('.media > img');
        if (!image) return;
        if (!this.originals.has(image)) this.originals.set(image, { src: image.getAttribute('src'), srcset: image.getAttribute('srcset'), alt: image.alt });
        const original = this.originals.get(image);
        const source = this.view === 'model' ? data.dataset.modelSrc : data.dataset.productSrc;
        if (data.dataset.appliedView === this.view) return;
        if (original.onError) image.removeEventListener('error', original.onError);
        original.onError = null;
        data.dataset.appliedView = this.view;
        container.classList.toggle('card-photo-active', Boolean(source));
        image.setAttribute('src', source || original.src);
        if (source) image.removeAttribute('srcset');
        else if (original.srcset) image.setAttribute('srcset', original.srcset);
        image.alt = source ? data.dataset[`${this.view}Alt`] : original.alt;
        if (source) {
          original.onError = () => {
            image.setAttribute('src', original.src);
            if (original.srcset) image.setAttribute('srcset', original.srcset);
            image.alt = original.alt;
            container.classList.remove('card-photo-active');
          };
          image.addEventListener('error', original.onError, { once: true });
        }
      });
      this.querySelectorAll('[data-photo-view]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.photoView === this.view)));
      this.querySelector('[data-photo-status]').textContent = this.view === 'model' ? 'Showing model photos where available.' : 'Showing product photos.';
    }
  }
  class UnavailableProductHelp extends HTMLElement {
    connectedCallback() {
      if (typeof subscribe !== 'function') return;
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data.sectionId !== this.dataset.section) return;
        this.hidden = Boolean(data.variant?.available);
      });
    }
    disconnectedCallback() { this.unsubscribe?.(); }
  }
  customElements.define('mobile-filter-panel', MobileFilterPanel);
  customElements.define('collection-photo-switch', CollectionPhotoSwitch);
  customElements.define('unavailable-product-help', UnavailableProductHelp);
})();
